/**
 * UX 第3周 C（申請・台帳の行の編集）の文言。i18n.ts が合成する。
 * i18n.ts 側のキー（req.returnedHelp）だけ上書きする。ほかの i18n/*.ts にあるキーは上書きしない。
 */
export const ja: Record<string, string> = {
  "req.returnedHelp": "差し戻されました。理由を確かめて、「この内容で出し直す」を押してください。",
};

export const en: Record<string, string> = {
  "req.returnedHelp": "This request was sent back. Check the reason, then press “Copy and resubmit”.",
};
